import { ServiceObject } from "../Interfaces";

export const serviceItems: ServiceObject[] = [
  // {
  //   title: 'Remote IT Support',
  //   description:
  //     'Our remote IT support services are designed to provide you with quick and efficient solutions to your IT issues. Our team of experts is available to assist you with any technical problems you may encounter.',
  //   color: '#007bff',
  //   SVG: (
  //     <svg
  //       width="24"
  //       height="24"
  //       xmlns="http://www.w3.org/2000/svg"
  //       fill-rule="evenodd"
  //       clip-rule="evenodd"
  //       className="fill-current text-base"
  //     >
  //       <path d="M21.172 11.486l-5.172-5.072 1.414-1.414 6.586 6.485-6.586 6.515-1.414-1.414 5.172-5.1zm-18.344 0l5.172-5.072-1.414-1.414-6.586 6.485 6.586 6.515 1.414-1.414-5.172-5.1zm4.672-1.486c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm9 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-4.5 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z" />
  //     </svg>
  //   ),
  //   pricing: [
  //     { tier: 'Less 25 Users', price: '$49 per User' },
  //     { tier: 'Less 250 Users', price: '$37 per User' },
  //     { tier: 'Less 600 Users', price: '$28 per User' },
  //     { tier: 'Enterprise', price: 'Contact Us' },
  //   ],
  // },
  {
    title: "Backup and Disaster Recovery",
    description:
      "Our Backup and Disaster Recovery (BDR) service is designed to safeguard your business's critical data and ensure rapid recovery in the event of unforeseen disruptions. Leveraging cutting-edge technology and best-in-class methodologies, we offer a comprehensive solution that minimizes downtime, protects data integrity, and enhances business resilience.",
    color: "#dc3545",
    key_features: [
      {
        name: "Automated Backups",
        desc: "Scheduled backups run automatically, ensuring that your data is consistently up-to-date without manual intervention.",
      },
      {
        name: "Secure Storage",
        desc: "Data is encrypted both in transit and at rest, and stored in geographically dispersed data centers to enhance security and availability.",
      },
      {
        name: "Scalability",
        desc: "Whether you’re a small business or a large enterprise, our service scales to meet your needs, accommodating growing data volumes seamlessly.",
      },
      {
        name: "Monitoring and Support",
        desc: "Our team of experts monitors your backup and recovery processes around the clock and is available to assist you at any time.",
      },
    ],
    SVG: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        className="fill-current text-base"
        key={111}
      >
        <path d="M18.516 18.448c1.648 1.946-1.365 3.802-2.292 1.451-.425-1.081-1.438-3.76-1.69-4.434-.313-.833.499-1.25 1.012-.557.34.459 2.263 2.706 2.97 3.54zm3.484-18.448v24h-20v-24h20zm-2 2h-16v20h1v-1.5c0-.276.224-.5.5-.5s.5.224.5.5v1.5h1v-1.5c0-.276.224-.5.5-.5s.5.224.5.5v1.5h1v-1.5c0-.276.224-.5.5-.5s.5.224.5.5v1.5h10v-20zm-8 7c-.551 0-1 .449-1 1s.449 1 1 1 1-.449 1-1-.449-1-1-1zm0-6c3.866 0 7 3.134 7 7 0 1.956-.804 3.723-2.098 4.993-.262-.314-.47-.569-.554-.682-.354-.478-.861-.753-1.391-.753-.485 0-.939.237-1.215.635-.311.449-.364 1.041-.145 1.623l.341.906c-.616.177-1.265.278-1.938.278-3.866 0-7-3.134-7-7s3.134-7 7-7zm-2.5 2.836c.656-.396 1.374-.605 2.091-.65l.12-.777c-.893.028-1.79.276-2.609.771-.818.492-1.455 1.171-1.897 1.947l.744.257c.374-.613.893-1.15 1.551-1.548zm.794 1.318c.334-.201.692-.324 1.056-.387l.121-.792c-.54.057-1.077.22-1.575.521-.496.3-.89.698-1.193 1.149l.756.264c.226-.293.501-.553.835-.755zm3.706 2.846c0-1.105-.895-2-2-2s-2 .895-2 2 .895 2 2 2 2-.895 2-2z" />
      </svg>
    ),
    pricing: [
      { tier: "Cloud Backup", price: "$0.67/GB" },
      { tier: "On Premise Backup", price: "$0.42/GB" },
    ],
  },
  {
    title: "Inventory Management",
    description:
      "Our self-hosted inventory management services empower you to take full control of your inventory processes. This solution is ideal for businesses looking to manage their inventory systems in-house, providing you with the tools and software to efficiently track and manage your stock while ensuring you are fully responsible for its oversight and operation.",
    color: "#28a745",
    key_features: [
      {
        name: "Real-time Tracking",
        desc: "Track inventory levels, orders, sales, and deliveries in real-time to stay informed and proactive.",
      },
      {
        name: "Data Accuracy",
        desc: "Reduce human errors with automated data entry and validation processes to maintain high accuracy in inventory records.",
      },
      {
        name: "Label Printing",
        desc: "Easily generate and print customized labels to tag and track your assets, enhancing the organization and accessibility of your inventory.",
      },
      {
        name: "Optimization Insights",
        desc: "Leverage data analytics to identify trends, optimize stock levels, and reduce costs, improving overall operational efficiency.",
      },
    ],
    SVG: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        className="fill-current text-base"
        key={222}
      >
        <path d="M5 7c2.761 0 5 2.239 5 5s-2.239 5-5 5-5-2.239-5-5 2.239-5 5-5zm11.122 12.065c-.073.301-.122.611-.122.935 0 2.209 1.791 4 4 4s4-1.791 4-4-1.791-4-4-4c-1.165 0-2.204.506-2.935 1.301l-5.488-2.927c-.23.636-.549 1.229-.943 1.764l5.488 2.927zm7.878-15.065c0-2.209-1.791-4-4-4s-4 1.791-4 4c0 .324.049.634.122.935l-5.488 2.927c.395.535.713 1.127.943 1.764l5.488-2.927c.731.795 1.77 1.301 2.935 1.301 2.209 0 4-1.791 4-4z" />
      </svg>
    ),
    pricing: [
      { tier: "Less 35 Items", price: "$49 per Item" },
      { tier: "Less 120 Items", price: "$38 per Item" },
      { tier: "Less 240 Items", price: "$26 per Item" },
      { tier: "Enterprise", price: "Contact Us" },
    ],
  },
  {
    title: "Ransomware Decryption",
    description:
      "Our ransomware decryption services are designed to help you recover your data and get your business back up and running as quickly as possible. We can help you decrypt your files and remove the ransomware from your systems.",
    color: "#ffc107",
    key_features: [
      {
        name: "Fast Response",
        desc: "Quick deployment of decryption tools to minimize downtime and mitigate potential losses.",
      },
      {
        name: "Comprehensive Analysis",
        desc: "Thorough analysis of ransomware variants to ensure effective decryption and prevention of future attacks.",
      },
      {
        name: "Recovery Assistance",
        desc: "Guidance through the recovery process to restore your data and secure your systems post-attack.",
      },
    ],
    SVG: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        className="fill-current text-base"
        key={333}
      >
        <path d="M20 18v-2c0-1.657-1.344-3-3-3s-3 1.343-3 3v2h-1v6h8v-6h-1zm-5 0v-2c0-1.103.897-2 2-2s2 .897 2 2v2h-4zm-4 5.314c0 .222-.127.424-.326.521l-.234.111c-.08.036-.169.054-.26.054-.325 0-.677-.223-.693-.61-.012-.249.129-.48.357-.586l.225-.104c.202-.096.439-.08.628.04.189.119.303.327.303.551v.023zm-.333-5.277c-.953.512-2.394 1.182-4.758 1.876-.295.087-.593-.056-.717-.285-.215-.365-.028-.835.382-.956 2.24-.66 3.543-1.267 4.47-1.764.201-.107.444-.103.641.015.195.118.315.329.315.557 0 .233-.128.447-.333.557zm-.563-2.956c-1.553 1.014-3.388 1.795-5.372 2.294-.32.081-.648-.095-.756-.405-.059-.173-.043-.363.045-.523s.238-.278.417-.323c4.046-1.021 7.628-3.346 9.157-6.958.725-1.71-.658-2.935-2.086-2.935-.86 0-1.738.444-2.182 1.494-.801 1.89-2.814 3.388-5.516 4.153-.401.115-.804-.181-.811-.596-.005-.297.192-.561.48-.643 2.309-.655 4.007-1.883 4.654-3.411.309-.731.805-1.328 1.432-1.726.573-.363 1.245-.555 1.943-.555 1.236 0 2.405.599 3.051 1.563.617.922.699 2.042.229 3.153-.469 1.105-1.123 2.139-1.944 3.071-.771.874-1.693 1.663-2.741 2.347zm.896 5.311c0 .228-.13.438-.334.54-.666.332-1.604.765-3.015 1.249-.446.153-.897-.287-.79-.762.051-.22.211-.398.426-.472 1.419-.49 2.149-.841 2.773-1.156.201-.102.439-.092.631.026.193.117.309.326.309.551v.024zm-7.021-16.237c.256-.586.518-.931.945-1.409 1.693-1.864 4.087-2.746 6.553-2.746 3.708 0 7.324 1.979 8.455 5.102.808 2.234.488 4.04.255 5.357l-.095.567c-.031.205-.157.382-.34.479s-.4.099-.586.008c-.254-.124-.397-.399-.355-.678l.101-.598c.22-1.242.493-2.788-.198-4.701-.781-2.159-3.151-3.796-6.037-4.173-3.038-.396-5.775.692-7.323 2.908l-.388.572c-.183.275-.534.347-.809.16-.28-.19-.345-.466-.178-.848zm.057 10.471c-.362.087-.72-.15-.78-.511-.056-.337.16-.661.495-.741 3.522-.849 6.195-2.776 7.253-5.273.139-.327.518-.48.848-.343s.484.514.346.841c-1.378 3.253-4.692 5.193-8.162 6.027zm-.442-6.733c1.404-.459 1.82-1.165 2.312-2.005.314-.534.669-1.139 1.287-1.709 1.406-1.294 3.31-1.919 5.224-1.715 1.827.195 3.444 1.119 4.438 2.536 1.385 1.974 1.037 3.929.759 5.5-.051.292-.306.503-.601.5h-.057999999999999996c-.184.002-.359-.077-.479-.216s-.17-.325-.138-.507c.262-1.477.532-3.005-.547-4.544-.779-1.111-2.061-1.837-3.514-1.993-1.541-.164-3.072.339-4.202 1.38-.478.44-.756.913-1.05 1.414-.569.97-1.154 1.967-3.035 2.58-.445.145-.89-.221-.831-.681.037-.279.213-.467.435-.54z" />
      </svg>
    ),
    pricing: [{ tier: "Hourly Rate", price: "$155 per hour" }],
  },
  {
    title: "Password Management",
    description:
      "Our password management services are designed to help you keep your passwords secure and easily accessible. We can group your passwords into categories and provide you with a secure access to only those who need it. No more sticky notes!",
    color: "#17a2b8",
    key_features: [
      {
        name: "Secure Encryption",
        desc: "Advanced encryption techniques ensure that your passwords remain secure against breaches.",
      },
      {
        name: "Browser Extension",
        desc: "Use our browser extension alongside our web platform to manage and auto-complete passwords seamlessly across all your online accounts.",
      },
      {
        name: "Custom Grouping",
        desc: "Organize your passwords into customizable groups for better management and access control.",
      },
    ],
    SVG: (
      <svg
        width="24"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        clip-rule="evenodd"
        className="fill-current text-base"
        key={444}
      >
        <path d="M12.804 9c1.038-1.793 2.977-3 5.196-3 3.311 0 6 2.689 6 6s-2.689 6-6 6c-2.219 0-4.158-1.207-5.196-3h-3.804l-1.506-1.503-1.494 1.503-1.48-1.503-1.52 1.503-3-3.032 2.53-2.968h10.274zm7.696 1.5c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z" />
      </svg>
    ),
    pricing: [
      { tier: "Less 25 Users", price: "$27 per User" },
      { tier: "Less 250 Users", price: "$19 per User" },
      { tier: "Less 600 Users", price: "$12 per User" },
      { tier: "Enterprise", price: "Contact Us" },
    ],
  },
  {
    title: "Wi-Fi Managment",
    description:
      "We offer a comprehensive WiFi management services designed to ensure seamless, secure, and high-performance wireless connectivity for your business or commerical property. Our team can handle every aspect of your WiFi network, from initial setup and configuration to ongoing monitoring and maintenance.",
    color: "#800080",
    key_features: [
      {
        name: "Custom Network Design",
        desc: "Tailored solutions that fit your unique environment and needs. This can include, segregation, guest portals, or even a radius configuration.",
      },
      {
        name: "Traffic Analytics",
        desc: "View the most visited sites on your wifi network.",
      },
      {
        name: "Enhanced Secuirty",
        desc: "Setup rules to block websites you do not want people visitng on your network.",
      },
    ],
    SVG: (
      <svg
        width="24"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        clip-rule="evenodd"
        key={555}
      >
        <path d="M12 20c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-3.659-3.254c1.013-.781 2.282-1.246 3.659-1.246 1.376 0 2.645.464 3.657 1.245l-.572.821c-.85-.667-1.921-1.066-3.085-1.066s-2.237.399-3.087 1.068l-.572-.822zm-2.859-4.105c1.825-1.346 4.079-2.141 6.518-2.141 2.437 0 4.691.794 6.515 2.139l-.572.821c-1.662-1.232-3.718-1.96-5.943-1.96-2.226 0-4.284.729-5.946 1.962l-.572-.821zm-2.858-4.104c2.635-1.91 5.875-3.037 9.376-3.037 3.499 0 6.737 1.125 9.371 3.034l-.571.821c-2.472-1.796-5.513-2.855-8.8-2.855-3.288 0-6.331 1.06-8.804 2.858l-.572-.821zm-2.624-3.768c3.402-2.375 7.54-3.769 12-3.769 4.458 0 8.593 1.392 11.994 3.765l-.571.82c-3.239-2.259-7.178-3.585-11.423-3.585-4.248 0-8.188 1.327-11.429 3.589l-.571-.82z" />
      </svg>
    ),
    pricing: [{ tier: "Installation", price: "Contact us" }],
  },
  {
    title: "AD Filtering",
    description:
      "Our ad filtering service is designed to enhance your online experience by blocking unwanted advertisements and ensuring a cleaner, faster, and more secure internet browsing experience. After it is setup, it will cover all your devices and will not need client side software.",
    color: "#FFA500",
    key_features: [
      {
        name: "Block ads Everywhere",
        desc: "This includes ads in, apps, browsers, games, and websites. Please note, this can not block ads that are provided by the same domain as the content provider, examples are youtube, amazon, and facebook",
      },
      {
        name: "Protects your privacy",
        desc: "This will block your information from online trackers and analytics systems.",
      },
      {
        name: "Filtering",
        desc: "Use the protection mode to even block access to certain websites.",
      },
      {
        name: "No app needed",
        desc: "All this requires is NETDS to setup a device on your network and you're done, no need for software installation!",
      },
    ],
    SVG: (
      <svg
        width="24"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        clip-rule="evenodd"
        key={666}
      >
        <path
          d="m17.5 11c2.484 0 4.5 2.016 4.5 4.5s-2.016 4.5-4.5 4.5-4.5-2.016-4.5-4.5 2.016-4.5 4.5-4.5zm-5.346 6.999c-.052.001-.104.001-.156.001-4.078 0-7.742-3.093-9.854-6.483-.096-.159-.144-.338-.144-.517s.049-.358.145-.517c2.111-3.39 5.775-6.483 9.853-6.483 4.143 0 7.796 3.09 9.864 6.493.092.156.138.332.138.507 0 .179-.062.349-.15.516-.58-.634-1.297-1.14-2.103-1.472-1.863-2.476-4.626-4.544-7.749-4.544-3.465 0-6.533 2.632-8.404 5.5 1.815 2.781 4.754 5.34 8.089 5.493.09.529.25 1.034.471 1.506zm6.053-2.499s.642-.642 1.061-1.061c.187-.187.187-.519 0-.707-.188-.187-.52-.187-.707 0-.419.419-1.061 1.061-1.061 1.061s-.642-.642-1.061-1.061c-.187-.187-.519-.187-.707 0-.187.188-.187.52 0 .707.419.419 1.061 1.061 1.061 1.061s-.642.642-1.061 1.061c-.187.187-.187.519 0 .707.188.187.52.187.707 0 .419-.419 1.061-1.061 1.061-1.061s.642.642 1.061 1.061c.187.187.519.187.707 0 .187-.188.187-.52 0-.707-.419-.419-1.061-1.061-1.061-1.061zm-6.585-.518c-2.031-.19-3.622-1.902-3.622-3.982 0-2.208 1.792-4 4-4 1.804 0 3.331 1.197 3.829 2.84-.493.146-.959.354-1.389.615-.248-1.118-1.247-1.955-2.44-1.955-1.38 0-2.5 1.12-2.5 2.5 0 1.363 1.092 2.472 2.448 2.499-.169.47-.281.967-.326 1.483z"
          fill-rule="nonzero"
        />
      </svg>
    ),
    pricing: [],
  },
];
